<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('zjmx.title')}}</div>
            <img class="icon2" src="@/assets/icon_hall_keep.png" alt="" @click="alert">
        </div>
        <div class="mescroll">
            <vue-better-scroll class="wrapper"
                         ref="scroll"                         
                         :scrollbar="scrollbarObj"
                         :pullDownRefresh="pullDownRefreshObj"
                         :pullUpLoad="pullUpLoadObj"
                         :startY="parseInt(startY)" 
                         :probeType="1"
                         :listenScroll=true
                         @scroll="scroll"                                             
                         @pulling-down="onPullingDown"
                         @pulling-up="onPullingUp">
                 <ul class="list-box">
                    <li class="list" v-for="(item,index) in listData" :key="index">                        
                        <div class="list-text-box">
                            <div>
                                <div class="text">{{item.title}}({{item.money_type | statusFilter}})</div>                            
                                <p class="time">{{item.create_time | times(timestamp)}}</p>
                            </div>
                            <div class="money">{{item.money}}</div>
                        </div> 
                        <div class="detail ellipses">{{item.content}}</div>                     
                    </li>                   
                </ul> 
                <no-data v-show="hasData"></no-data>    
            </vue-better-scroll>
           <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
        </div>
        <div class="mask-cont" v-show="mask">            
            <div class="bg-box">
                <ul class="time-box">
                    <li class="time-list"><input class="time" type="text" @click="setDate" :placeholder="this.$t('wdkj.kssj')" v-model="startTime" readonly></li>
                    <li class="time-list">－</li>
                    <li class="time-list"><input class="time" type="text" @click="setDate2" :placeholder="this.$t('wdkj.jssj')" v-model="endTime" readonly></li>
                </ul>  
                <ul class="lei-box">                              
                    <li class="lei-list" v-for="(item,index) in typeData" :key="index"  @click="changeType(item.id)" :class="{active:curTypeId == item.id}" :style="{height: height}">{{item.name}}</li>                                  
                </ul>   
                <ul class="lei-box">   
                    <li class="lei-list" @click="changeBz(0,0)" :class="{active:curBzIdx == 0}">{{this.$t('zjmx.lx[0].name')}}</li>                             
                    <li class="lei-list" @click="changeBz(1,1)" :class="{active:curBzIdx == 1}">GDCC</li>  
                    <li class="lei-list" @click="changeBz(2,2)" :class="{active:curBzIdx == 2}">USDT</li> 
                    <li class="lei-list" @click="changeBz(3,3)" :class="{active:curBzIdx == 3}">ETH</li> 
                    <li class="lei-list" @click="changeBz(4,4)" :class="{active:curBzIdx == 4}">BTC</li> 
                    <li class="lei-list" @click="changeBz(5,5)" :class="{active:curBzIdx == 5}">TRX</li>                               
                </ul>     
            </div>    
            <ul class="btn-box">               
                <!-- 确认 -->
                <li class="btn reset" @click="cancle">{{this.$t('wdkj.reset')}}</li>
                <li class="btn sure" @click="sure">{{this.$t('zjmx.qr')}}</li>
            </ul>
        </div>  
        <div class="mask" v-show="mask" @click="hidden"></div> 
        <mt-datetime-picker
            ref="picker"                
            type="date"
            v-model="startTime"
            :startDate="startDate"  
            :cancelText="cancelText"  
            :confirmText="confirmText"
            @confirm="dateConfirm"
            @touchmove.native.stop.prevent>
        </mt-datetime-picker>
        <mt-datetime-picker
            ref="picker2"               
            type="date"
            v-model="endTime"
            :startDate="startDate"  
            :cancelText="cancelText"  
            :confirmText="confirmText"            
            @confirm="dateConfirm2"
            @touchmove.native.stop.prevent>
        </mt-datetime-picker>
    </div>
</template>
<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that;
export default {
    name: 'capitalDetails',
    data () {
        return {
            uid: '',
            token: '',
            lang: '',
            height: 'auto',
            mask: false,
            curBzIdx: 0,
            isCalendarShow: false,
            hasData: false,  
            isTop: false,          
            curTypeId: 0, 
            money_type: '',
            isClick: 'start',
            listData: [],//资金明细
            typeData:[],//分类            
            page: 1,
            year: '',
            isReset: false,
            startTime: '',
            startTimes: '',
            endTimes: '',
            startDate: '',
            selectedValue: '',
            endDate:'',
            endTime:'',
            cancelText: '',
            confirmText: '',    
            statusText: [],//提现审核文本状态                      
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')              
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')                    
                }
            },
            startY: 0, // 纵轴方向初始化位置            
            scrollToY: 0,
            scrollToTime: 500,
            limit: 20,
            timestamp: 0, 
        }
    },  
    beforeCreate() {
        that = this;
    },
    created(){
        this.startDate = new Date('2015/1/1');        
        this.endDate = new Date(); 
        this.cancelText = this.$t('duihuang.qx');   
        this.confirmText = this.$t('wdkj.sure'); 
    },
    mounted() {
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token'); 
        this.lang = localStorage.getItem('user_lang');
        this.timestamp = localStorage.getItem('timestamp') || 0;
        if(this.lang == 'en'){
            this.height = '1.1rem'
        }else{
            this.height = 'auto'
        }
        this.statusText = this.$t('zjmx.status');  
        this.typeData = this.$t('zjmx.lx');  
        this.init();//资金明细   
    },
    methods: {         
        scroll({x, y}){
            if(Math.abs(y) >= 300){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },    
        // 滚动到页面顶部
        scrollTo() {            
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
        init(startTimes,endTimes){//资金明细
            let params = {
                uid: this.uid,
                token: this.token,
                start_time: this.startTimes,
                end_time: this.endTimes,
                type: this.curTypeId,    
                money_type: this.money_type,                          
                page: 1,
                limit: this.limit
            }  
            this.$ajax.post('/api/member/profitList',params).then((res) => {                
                let resData = res.data.data;                 
                if(res.data.code == 200){
                    if(resData.length > 0){        
                        this.hasData = false
                        this.listData = resData; 
                        this.$refs.scroll.forceUpdate(true)        
                    }else{
                        this.hasData = true;                       
                    }
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err)
            })   
        },       
        /* 下拉刷新的回调 */
        onPullingDown () {
            this.listData = []; 
            this.page = 1;
            this.init()
        },
        onPullingUp(){            
            this.page ++;
            let params = {
                uid: this.uid,
                token: this.token,
                start_time: this.startTimes,
                end_time: this.endTimes,
                type: this.curTypeId,   
                money_type: this.money_type,                                
                page: this.page,
                limit: this.limit
            } 
            this.$ajax.post('/api/member/profitList',params).then((res) => {                
                let resData = res.data.data;         
                if(res.data.code == 200){                                          
                    if(resData.length > 0){
                        this.listData = this.listData.concat(resData);                        
                        this.$refs.scroll.forceUpdate(true) 
                    }else{
                        this.$refs.scroll.forceUpdate(false) 
                    }                
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err); 
            })   
        },   
        goBack(){
            this.$router.go(-1);
        },
        alert(){
            this.isReset = true;
            this.startTime = '';
            this.endTime = '';    
            this.startDate = new Date('2015/1/1');        
            this.endDate = new Date();  
            this.mask = true;
        },
        hidden(){
            this.mask = false;
            this.isCalendarShow = false;
        },
        changeType(id){
            this.curTypeId = id;
            this.isCalendarShow = false
        },  
        changeBz(idx,type){
            this.curBzIdx = idx;
            this.money_type = type;
        },           
        sure(){
            if(this.startTime){
                if(this.endTime == ''){
                    this.$toast.bottom(this.$t('wdkj.qxzjssj'));
                    return;
                }
            } 
            if(this.endTime){
                if(this.startTime == ''){
                    this.$toast.bottom(this.$t('wdkj.qxzkssj'));
                    return;
                }
            }                
            let startTimes = parseInt(new Date(this.startTime).getTime()/1000);
            let endTimes = parseInt(new Date(this.endTime).getTime()/1000);
            if(startTimes > endTimes){
                this.$toast.bottom(this.$t('wdkj.sjsxts'));
                return;
            }else if(startTimes == endTimes){
                this.$toast.bottom(this.$t('wdkj.sjsxts2'));
                return;
            }     
            this.startTimes = startTimes;
            this.endTimes = endTimes;                
            this.mask = false;
            this.listData = [];
            this.page = 1;
            this.init(startTimes,endTimes);
            this.startTime = '';
            this.endTime = '';
        },
         setDate(){   
            this.isReset = false; 
            if(this.selectedValue) {
                this.startTime = this.selectedValue;
            }else {
                this.startTime = this.formatDate(new Date());
            }
            this.$refs.picker.open();
        },
        setDate2(){   
            this.isReset = false;            
            if(this.selectedValue) {
                this.endTime = this.selectedValue
            }else {
                this.endTime = this.formatDate(new Date());
            }
            this.$refs.picker2.open();
        },
        dateConfirm(){ // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
            this.startTime = this.formatDate(this.$refs.picker.value);  
            this.selectedValue = this.formatDate(this.$refs.picker.value);                              
        },
        dateConfirm2(){ // 时间选择器确定按钮，并把时间转换成我们需要的时间格式            
            this.endTime = this.formatDate(this.$refs.picker2.value);  
            this.selectedValue = this.formatDate(this.$refs.picker2.value);
        },
        formatDate(data) { 
            const y = data.getFullYear();
            let m = data.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = data.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + m + '-' + d
        },
        showDate(){ 
            this.isReset = true;
            this.startTime = '';
            this.endTime = '';    
            this.startDate = new Date('2015/1/1');        
            this.endDate = new Date();       
            this.isMask = true;
            this.isDate = true;
        },
        cancle(){                 
            this.isReset = true;
            this.selectedValue = '';          
            this.startTime = '';
            this.endTime = ''; 
            this.curTypeId = 0;
            this.money_type = '';
            this.curBzIdx = 0;            
        }
    },  
    watch: {
        startTime: function(val){               
            if(val != 'Invalid Date'){
                if(val == ''){
                    this.startTime = ''
                }else{
                    if(this.isReset){
                        this.startTime = ''
                    }else{
                        this.startTime = this.formatDate(val)
                    }                    
                }            
            }else{
                 this.startTime = ''
            }                 
        },
        endTime: function(val){
            if(val != 'Invalid Date'){
                if(val == ''){
                    this.endTime = ''
                }else{
                    if(this.isReset){
                        this.endTime = ''
                    }else{
                        this.endTime = this.formatDate(val)
                    }                    
                }            
            }else{
                 this.endTime = ''
            }    
        }
    },  
    filters: {
        statusFilter: (val) => { 
            if(val == 1){
                return 'GDCC'
            }else if(val == 2){
                return 'USDT'
            }else if(val == 3){
                return 'ETH'
            }else if(val == 4){
                return 'BTC'
            }else if(val == 5){
                return 'TRX'
            }else{
                return 'GDCC'
            }
        },
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();            
            return Y + M + D + " " + h + m + s;
        } 
    },
    components:{
        noData,
        VueBetterScroll        
    }   
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #fff;
        font-size: .24rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;  
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
        overflow: hidden;       
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: .8rem;
        font-size: .36rem;
        line-height: .8rem;
        /* background: #0e1530; */
        text-align: center;
    }    
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .18rem;
        width: .24rem;
        height: .44rem;     
    }  
    .head .icon2{
        position: absolute;
        top: 50%;
        right: .1rem;
        width: .34rem;
        /* height: .32rem;  */
        transform: translate(-50%,-50%);             
    }
    .list-box{        
        padding: 0 .3rem;
    }
    .list-box .list{  
        margin-bottom: .22rem;
        padding: .26rem .24rem .18rem .3rem;
        color: #fff;
        font-size: .28rem;   
        border-radius: 4px;
        background: rgb(26, 36, 63,.5);
        /* background: #1a243f;     */
    }
    .list-box .list-text-box{
        display: flex;
        justify-content: space-between;   
        align-items: center;        
    }
    .list-box .money{
        display: flex;
        justify-content: space-between;   
        align-items: center;  
        color: #4bb3e8;
        /* font-weight: bold; */
    }
    .list-box .c1{
        color: #fff;
    }
    .list-box .list .time{
        margin-top: .18rem;
        color: #fff;
        font-size: .24rem;
    }
    .list-box .list .list-text{
        flex: 1;
    }
    .list-box .list .detail{
        padding-top: .24rem;
        color: #d9d9d9;
        font-size: .24rem;
        word-break: break-all;
    }
    .list-box .list .arrow{
        width: .18rem;
        height: .3rem;
        margin-right: .1rem;    
    } 
    .list-box .list .status{
        padding: 0 .4rem;
        color: #ff5757;
        font-size: .24rem;
    }   

    .mask{
        position: absolute;
        left: 0;
        top: .8rem;
        z-index: 99;
        width: 100%;
        height: calc(100% - .8rem);
        background: rgba(0,0,0,.5); 
    }
    .mask-cont{
        position: absolute;
        right: 0;
        top: .8rem;
        bottom: 0;
        z-index: 100;
        width: 4.6rem;
        height: auto;
        color: #000;
        font-size: .24rem;
        padding: 0 .2rem;
        background: rgba(26, 36, 63,.9);
    }  
    .mask-cont .bg-box{
        position: absolute;
        top: 0;
        bottom: 1.4rem;
        width: 100%;
        height: auto;
        overflow-y: auto;
    }  
    .mask-cont .tips{
        padding: .2rem 0;
    }
    .mask-cont .time-box{
        display: flex;
        align-items: center;
        margin-top: .5rem;
        color: #fff;
    }
    .mask-cont .time-list{
        margin-right: .2rem;
    }
    .mask-cont .time{
        width: 1.8rem;
        padding: .1rem;
        color: #fff;
        font-size: .24rem;
        border-radius: .07rem;
        background: #415792;
        text-align: center;
    }
    .lei-box{
        display: flex;
        flex-wrap: wrap;
        margin-top: .4rem;
        /* padding-left: .12rem; */
        text-align: center;
    }
    .lei-box .lei-list{     
        display: flex;   
        justify-content: center;
        align-items: center;
        width: 2.2rem;
        margin: 0 .22rem .2rem 0;
        padding: .16rem .1rem;
        color: #fff;
        font-size: .24rem;        
        border-radius: .07rem;
        background: rgba(65, 87 ,146,.5);
        box-sizing: border-box;
        text-align: center;
    }
    /* .lei-box .lei-list:nth-child(2n){
        margin: 0  0 .2rem 0;
    } */
    .lei-box .lei-list.active{
        color: #fff;
        background: #2CAADE;
    }

    .btn-box{
        position: absolute;
        left: .24rem;
        right: .24rem;
        bottom: .5rem;  
        display: flex;   
        justify-content: space-between;  
        align-items: center; 
        width: auto;        
    }
    .btn-box .btn{
        width: 2rem;
        text-align: center;
    }
    .btn-box .btn.reset{
        height: .76rem;
        color: #fff;
        font-size: .32rem;
        line-height: .76rem;       
        background: #2CAADE;
        border-radius: .14rem;
    }
    .btn-box .btn.sure{
        height: .76rem;
        color: #fff;
        font-size: .32rem;
        line-height: .76rem;       
        background: #415792;
        border-radius: .14rem;
    }
    .calendar{
        position: absolute;
        bottom: 0;
        z-index: 101;
        width: 100%;
        color: #000;
    }
    .mescroll{
        position: fixed;
        left: 0;
        top: .8rem;
        bottom: 0;
        z-index: 99;
        width: 100%;
        height: auto;
        padding-top: .5rem;
        color: #cecece;
        font-size: .24rem;
        /* background: #0e1530;  */
        overflow: hidden;      
    } 
</style>


// WEBPACK FOOTER //
// src/pages/capitalDetails.vue